<template>
  <div class="market-couponGrant-add">

      <el-form ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="100px"  v-loading="typeIDLoad"  element-loading-text="加载中" >
          <el-form-item label="发券对象" prop="userTargetType">
              <el-radio-group v-model="form.userTargetType">
                  <el-radio label="Member">指定会员</el-radio>
                  <el-radio label="Portrait" v-if="USER_BUTTON_AUTH.indexOf('market:coupon:task:portrait') >= 0">指定画像</el-radio>
                  <el-radio label="Label" v-if="USER_BUTTON_AUTH.indexOf('market:coupon:task:label') >= 0">指定标签</el-radio>
              </el-radio-group>
          </el-form-item>

          <el-form-item v-if="form.userTargetType == 'Member'" prop="userIds" label="" label-width="130px">
              <select-member :form="form" @change="onMemberChange" :isBatchImport="isEdit == 2" ></select-member>
          </el-form-item>
          <el-form-item v-if="form.userTargetType == 'Portrait'" prop="portraitIds" label="" label-width="230px">
              <el-select v-model="form.portraitIds" placeholder="请选择画像（最多可选3条）" filterable multiple collapse-tags
                  :multiple-limit="3">
                  <el-option v-for="item in portrayalData" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item v-if="form.userTargetType == 'Label'" prop="labelIds" label="" label-width="350px">
              <el-select v-model="form.labelIds" placeholder="请选择标签（最多可选3条）" filterable multiple collapse-tags
                  :multiple-limit="3">
                  <el-option v-for="item in tagData" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
          </el-form-item>

          <el-form-item label="发放时间" prop="grantTime">
              <el-radio-group v-model="form.grantTime">
                  <el-radio label="0">立即发放</el-radio>
                  <el-radio label="timeout">定时发放</el-radio>
              </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.grantTime == 'timeout'" prop="startTime" label="" label-width="200px">
              <el-date-picker v-model="form.startTime" type="datetime" placeholder="请选择发放时间" format="yyyy-MM-dd HH:mm"
                  :picker-options="pickerOptions" @change="handleTime" value-format="timestamp">
              </el-date-picker>
          </el-form-item>

          <el-form-item label="券类型" prop="typeId" >
              <el-radio-group v-model="form.typeId"  @change="handleType">
                  <el-radio label="1">优惠券</el-radio>
                  <el-radio label="2">礼品券</el-radio>
                  <el-radio label="3">停车券</el-radio>
              </el-radio-group>
          </el-form-item>

          <el-form-item :label="label[form.typeId - 1]" prop="couponIds"
              v-if="form.typeId == 1 || form.typeId == 2 || form.typeId == 3">
              <el-select v-model="form.couponIds" :placeholder="labelPla[form.typeId - 1]" @change="onCouponChange" multiple
                  collapse-tags>
                  <el-option v-for="item in couponData" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
          </el-form-item>
          <!-- 优惠券 -->
          <div class="coupon-table" v-if="form.typeId == 1">
              <Table :tableThData="tableThData" :tableTrData="tableTrData" :pagination="false">
                  <template #name="{ row }">{{ row.name }}</template>
                  <template #type="{ row }">{{ row.type }}</template>
                  <template #detail="{ row }">{{ row.detail }}</template>
                  <template #require="{ row }">{{ row.require }}</template>
                  <template #useTime="{ row }">{{ row.useTime }}</template>
                  <template #amount="{ row }">
                      <el-input type="text" v-model="row.amount" oninput="value=value.replace(/[^\d]/g,'')"
                          style="width: 100px;" />
                  </template>
              </Table>
          </div>
          <!-- 礼品券 -->
          <div class="coupon-table" v-if="form.typeId == 2">
              <Table :tableThData="tableThData" :tableTrData="tableTrData" :pagination="false">
                  <template #name="{ row }">{{ row.name }}</template>
                  <template #subTitle="{ row }">{{ row.subTitle }}</template>
                  <template #imageUrl="{ row }"><img class="img" :src="row.imageUrl"
                          alt=""></template>
                  <template #useTime="{ row }">{{ row.useTime }}</template>
                  <template #useRangeType="{ row }">{{ row.useRangeType }}</template>
                  <template #description="{ row }">
                      <el-button v-if="row.description && form.typeId == 2" type="text"
                          @click="onLookRemark(row)">查看使用须知</el-button>
                      <span v-else>---</span>
                  </template>
                  <template #amount="{ row }">
                      <el-input type="text" v-model="row.amount" oninput="value=value.replace(/[^\d]/g,'')"
                          style="width: 100px;" />
                  </template>
              </Table>
          </div>
          <!-- 停车券 -->
          <div class="coupon-table" v-if="form.typeId == 3">
              <Table :tableThData="tableThData" :tableTrData="tableTrData" :pagination="false">
                  <template  #mallName="{ row }">{{ row.mallName }}</template>
                  <template  #name="{ row }">{{ row.name }}</template>
                  <template  #discount="{ row }">{{ row.discount }} </template>
                  <template  #validTime="{ row }">{{ row.validTime }}</template>
                  <template #amount="{ row }">
                      <el-input type="text" v-model="row.amount" oninput="value=value.replace(/[^\d]/g,'')"
                          style="width: 100px;" />
                  </template>
              </Table>
          </div>

      </el-form>

      <div class="footer">
          <el-button @click="onBack" class="mr20">取消</el-button>
          <el-button type="primary" @click="onSubmit" :loading="submitLoading">提交</el-button>
      </div>
      <el-dialog :visible="isShowRemarkDialog" title="使用须知" :before-close="() => this.isShowRemarkDialog = false" width="30%">
          <div class="remark-box" v-html="currentRow.description"></div>
      </el-dialog>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import SelectMember from '@/components/SelectMember'
import Table from "@/components/Table/index";
import { api_getListLabel, api_getListPortrait, api_getListRTCoupon, api_getGiftListCoupon} from '@/api/common'
import { api_getParkingCouponTemplate } from '@/api/parking'
import { api_postCouponGrantAdd ,api_getUpdateExcel} from '@/api/market'
import { getStorage } from '@/utils/index'
export default {
  name: "marketCouponGrantAdd",
  components: {
      Table,
      AuthButton,
      SelectMember
  },
  data() {
      return {
          typeIDLoad:false,
          submitLoading: false,
          USER_BUTTON_AUTH:[],
          form: {
              userTargetType: 'Member',
              grantTime: '0',
              typeId: '1',
              userIds:[],
          },
          rules: {
              userTargetType: [{ required: true, message: '请选择发券对象' }],
              userIds: [{ required: true, message: '请选择指定会员', trigger: 'blur' }],
              portraitIds: [{ required: true, message: '请选择画像' }],
              labelIds: [{ required: true, message: '请选择标签' }],
              grantTime: [{ required: true, message: '请选择发放时间' }],
              typeId: [{ required: true, message: '请选择发放类型' }],
              startTime: [{ required: true, message: '请选择定时发放时间' }],
              couponIds: [{ required: true, message: '请选择优惠券', trigger: 'blur' }],
          },

          pickerOptions: {
              disabledDate(time) {
                  return time.getTime() < Date.now() - 1 * 24 * 3600 * 1000 //选当前时间之后的时间
              }
          },

          portraitData: [], // 会员list数据
          portrayalData: [], // 画像数据
          tagData: [], // 标签数据
          couponData: [], // 优惠券list数据
          tableThData: [
              { prop: "name", label: "优惠券名称", minWidth: "180", },
              { prop: "type", label: "优惠券类型", minWidth: "90", },
              { prop: "detail", label: "券优惠", minWidth: "120", },
              { prop: "require", label: "券门槛", minWidth: "180", },
              { prop: "useTime", label: "用券时间", minWidth: "280", },
              { prop: "amount", label: "发放数量", minWidth: "200", },
          ],
          tableTrData: [],
          label: ['优惠券', '礼品券', '停车券'],
          labelPla: ['请选择优惠券', '请选择礼品券', '请选择停车券'],
          currentRow: {},//礼品券-查看须知相关
          isShowRemarkDialog: false,//礼品券-查看须知相关
          isEdit:1,
      };
  },
  created() {
      this.getCouponListData() // 获取优惠券列表数据
      this.getPortrayalData() // 获取画像数据
      this.getTagData() // 获取标签数据
      this.USER_BUTTON_AUTH = getStorage('USER_BUTTON_AUTH')
      //如果是编辑进来的
      if(this.$route.params.userIds){
        this.isEdit = 2
        this.form.userIds = this.$route.params.userIds.split(',')
        console.log('导入用户id列表',this.form.userIds)
      }
  },
  methods: {
      // 获取画像数据
      async getPortrayalData() {
          const res = await api_getListPortrait()
          this.portrayalData = res
      },

      // 获取标签数据
      async getTagData() {
          const res = await api_getListLabel()
          this.tagData = res
      },

      // 获取优惠券列表数据
      async getCouponListData() {
        try {
          this.couponData = []
          const res = await api_getListRTCoupon()
          this.typeIDLoad = false
          this.couponData = res
        } catch (error) {
            this.typeIDLoad = false
        }
      },

      // 获取礼品券列表数据
      async getGiftListCoupon() {
        try {
          this.couponData = []
          const res = await api_getGiftListCoupon()
          this.typeIDLoad = false
          this.couponData = res
        } catch (error) {
            this.typeIDLoad = false
        }
      },

      // 获取停车券列表数据
      async getParkingCouponTemplate() {
        try {
          this.couponData = []
          const res = await api_getParkingCouponTemplate()
          this.typeIDLoad = false
          this.couponData = res
        } catch (error) {
            this.typeIDLoad = false
        }
      },

      // 券选择改变
      onCouponChange(value) {
          let selectData = []
          this.couponData.forEach(item => {
              if (value.indexOf(item.id) >= 0) {
                  selectData.push(item)
              }
          })
          this.tableTrData = selectData
          console.log(this.tableTrData)
      },

      // 指定会员选择改变
      onMemberChange(value) {
        console.log(value)
          this.form.userIds = value
          console.log(this.form.userIds)
      },

      // 限制选择时间(选择的时间如果小于当前时间，会自动替换成当前时间)
      handleTime() {
          var startAt = new Date(this.form.startTime) * 1000 / 1000;
          if (startAt < Date.now()) {
              this.form.startTime = this.$moment().valueOf();
          }
      },

      //选择优惠券类型
      handleType() {
        this.typeIDLoad = true //开启等待
          this.tableTrData = []
          this.form.couponIds = [] //清空选择的数据
          console.log(this.form.typeId)
          if (this.form.typeId == 1) {
              this.getCouponListData() // 获取优惠券列表数据
              this.tableThData = [
                  { prop: "name", label: "优惠券名称", minWidth: "180", },
                  { prop: "type", label: "优惠券类型", minWidth: "90", },
                  { prop: "detail", label: "券优惠", minWidth: "120", },
                  { prop: "require", label: "券门槛", minWidth: "180", },
                  { prop: "useTime", label: "用券时间", minWidth: "280", },
                  { prop: "amount", label: "发放数量", minWidth: "200", },
              ]
          } else if (this.form.typeId == 2) {
              this.getGiftListCoupon() // 获取礼品券列表数据
              this.tableThData = [
                  { prop: "name", label: "礼品券名称", minWidth: "180", },
                  { prop: "subTitle", label: "标题", minWidth: "110", },
                  { prop: "imageUrl", label: "图片", minWidth: "110", },
                  { prop: "useTime", label: "券有效时间", minWidth: "160", },
                  { prop: "useRangeType", label: "核销范围", minWidth: "120", },
                  { prop: "description", label: "使用须知", minWidth: "120", },
                  { prop: "amount", label: "发放数量", minWidth: "200", },
              ]
          } else if (this.form.typeId == 3) {
              this.getParkingCouponTemplate() // 获取停车券列表数据
              this.tableThData = [
                  { prop: "name", label: "停车券名称", minWidth: "180", },
                  { prop: "mallName", label: "商场名称", minWidth: "180", },
                  { prop: "discount", label: "抵扣优惠", minWidth: "110", },
                  { prop: "validTime", label: "券有效时间", minWidth: "160", },
                  { prop: "amount", label: "发放数量", minWidth: "200", },
              ]
          }
      },

      // 点击提交按钮
      onSubmit() {
        let that = this
          this.$refs.form.validate(async (valid) => {
              if (valid) {
                  try {
                      this.submitLoading = true
                      let { startTime = '', grantTime } = this.form
                      let params = {
                          ...this.form,
                          startTime: grantTime == '0' ? this.$moment().valueOf() : startTime
                      }

                      // 处理优惠券列表数据
                      let isAmount = true
                      params.templateAmounts = this.tableTrData.map(item => {
                        console.log(item)

                          if (item.amount === undefined && isAmount) {
                              isAmount = false
                          }
                          return {
                              id: item.id,
                              amount: item.amount,
                              name:item.name,
                              type:this.form.typeId
                          }
                      })
                      if (!isAmount) {
                          this.$baseMessage('请输入优惠券发放数量', 'warning')
                          this.submitLoading = false
                          return
                      }

                      delete params.grantTime // 删除发放时间类型
                      delete params.couponIds // 删除券id
                      console.log('params: ', params);
                      console.log(this.couponData)
                      // return
                      console.log(that.isEdit)
                      //编辑更新
                      if(that.isEdit == 2){
                        params.id = this.$route.params.id
                         const res = await api_getUpdateExcel(params)
                         this.$baseMessage('编辑成功', 'success')
                      }

                      //直接添加
                      if(that.isEdit == 1){
                       const res = await api_postCouponGrantAdd(params)
                       this.$baseMessage('操作成功', 'success')
                      }
                    //   console.log('res: ', res);
                      this.onBack()
                      this.submitLoading = false
                  } catch {
                      this.submitLoading = false
                      this.$baseMessage('操作失败', 'error')

                  }
              }
          })
      },
      // 查看使用须知
      onLookRemark(row) {
          this.currentRow = row
          this.isShowRemarkDialog = true
      },
      // 返回
      onBack() {
          this.$router.back(-1)
      },
  },
  watch: {},
  computed: {},
};
</script>

<style lang="scss" scoped>
.market-couponGrant-add {
  padding: 35px 20px 0 20px;
  padding-bottom: 100px;
  box-sizing: border-box;

  .coupon-table {
      margin-left: 100px;
  }
  .input-remark {
      height: 17px;
      line-height: 17px;
      font-size: 12px;
      color: #999999;
      position: absolute;
      left: 350px;
      bottom: 0;
  }

  ::v-deep {
      .el-radio-group {
        width: 100%;
          .el-radio-button__inner {
              height: 34px;
              padding: 0;
              line-height: 34px;
              margin-right: 1px;
              width: 100px;
              border: 0;
          }

          .el-radio-button:first-child {
              .el-radio-button__inner {
                  border-radius: 2px 0px 0 0;
              }
          }

          .el-radio-button:last-child {
              .el-radio-button__inner {
                  border-radius: 0 2px 0 0;
              }
          }
      }

      .el-input,
      .el-textarea,
      .el-select {
          width: 350px;
      }

      .component-select-member {


          .el-pagination {
              .el-pagination__sizes {

                  .el-input,
                  .el-select {
                      width: 110px;
                  }

              }

              .el-input {
                  width: 50px;
              }
          }

      }

      .short.el-input {
          width: 156px;
      }

      .el-range-editor.el-input__inner {
          width: 350px;
          background: #F2F3F5;
          border: 0;

          input {
              background: #F2F3F5;
              border: 0;
          }
      }

      .el-range-editor.el-input__inner.is-active {
          width: 350px;
          background: #fff;
          border: 1px solid #05C8AF;

          input {
              background: #fff;
              border: 0;
          }
      }

      .desc {
          color: #999;
          font-size: 12px;
      }
  }

  .footer {
      position: fixed;
      bottom: 0;
      padding: 20px 0;
      padding-left: 70px;
      background: #fff;
      width: calc(100vw - #{$base-left-menu-width});
      left: $base-left-menu-width;
      z-index: 999;
  }


  .img {
      width: 50px;
      height: 50px;
  }
}
</style>
